import React, {Component} from "react"
import '../../../styles/ProductCtrlPanel.css';
import {Card, Dialog, Checkbox} from "@vitalsource/vstui";
import {  Ellipsis as EllipsisIcon,
          Delete as DeleteIcon,
          Copy as DuplicateIcon,
          AddNote as EditIcon} from "@vitalsource/vstui-icons";
import Closeable from "../Closeable";
import {ProductCardButtonAction} from "../../types/Types";
import styled from "styled-components";
import { createTheme } from "@vitalsource/vstui/themes";
import {
  red,
  jungle,
  ocean
} from '@vitalsource/vstui/colors';
import {PRODUCT_STATUS} from "../../utils/constants";

const theme = createTheme({
  color: {
    primary: red,
  },
});

enum EllipsisColor {
  GREY = "GREY",
  WHITE = "WHITE"
}

const DeleteModal = styled(Dialog)`
  font-family: "Roboto";
  font-size: 15px;
  line-height: 21px;`;

const ModalLabel = styled.div`
  font-weight: 700;
  font-size: 15px;
  color: #3C3C3C;
  line-height: 21px;`;

const ModalValue = styled.div`
  color: #000000;
  max-width: 325px;
  white-space: normal;`;

export interface ProductCtrlPanelProps {
  productName: string;
  numberOfScreens: number;
  publishDate: string;
  status: string;
  deleteProduct: () => void;
  editProduct: () => void;
  duplicateProduct: () => void;
}

export interface ProductCtrlPanelState {
  isFullPanel: boolean;
  isConfirmationDialogShown: boolean;
  enableContinueDelete: boolean;
  btnHovered: string;
  validationMessage: string;
}

class ButtonPanel extends Component<ProductCtrlPanelProps, ProductCtrlPanelState> {
  deleteCBXRef: any;
  VSTUIButtonColor: string;

  constructor(props: ProductCtrlPanelProps) {
    super(props);

    this.state = {
      isFullPanel: false,
      isConfirmationDialogShown: false,
      enableContinueDelete: false,
      btnHovered: "",
      validationMessage: "",
    };

    this.VSTUIButtonColor = "#007FAD"

    this.setIsFullPanel = this.setIsFullPanel.bind(this);
  }

  handleDeleteConfirmationClick = () => {
    if (this.state.enableContinueDelete) {
      this.setIsConfirmationDialogShown(false);
      this.props.deleteProduct();
    }
    else if (!this.state.enableContinueDelete) {
      this.setState({ validationMessage: 'Required' });
      this.deleteCBXRef.focus();
      return;
    }
  };

  checkboxClicked = (checkboxValue: boolean) => {
    if (!checkboxValue) {
      this.setState({ validationMessage: 'Required' });
      this.deleteCBXRef.focus();
      return;
    }
  }

  getConfirmationDialog() {
    return (<DeleteModal
      alert
      theme={theme}
      closeButtonLabel=""
      onRequestClose= { () => this.setIsConfirmationDialogShown(false)}
      open={this.state.isConfirmationDialogShown}
      primaryActionButton={{
        label: 'Delete',
        onClick: () => {
          this.handleDeleteConfirmationClick()
        }}
      }
      rootSelector="#productButtonPanel"
      secondaryActionButton={{
        label: 'Cancel',
        onClick: () => { this.setIsConfirmationDialogShown(false)},
      }}
      size="medium"
      title=""
    >
      <div>
        <ModalLabel>You are about to delete: </ModalLabel>
        <ModalValue>{this.props.productName}</ModalValue>
      </div>
      <br/>
      <div>
        <ModalLabel>This contains: </ModalLabel>
        <ModalValue>{this.props.numberOfScreens || 0 } {this.props.numberOfScreens !== 1 ? "Screens" : "Screen"}</ModalValue>
      </div>
      <br/>
      <div>
        <ModalLabel>This was published to Bookshelf on: </ModalLabel>
        <ModalValue>{this.props.publishDate ? new Date(this.props.publishDate).toLocaleDateString("en-us", {month: "short", day: "numeric", year:"numeric"}).toString() : "Not Yet Published"}</ModalValue>
      </div>
      <br/>
      <div>
        <Checkbox fullWidth
                  onChange={ (e: any) => {
                    this.setState({
                      enableContinueDelete: e.target.checked
                    })
                  }}
                  label="I understand that I will lose all of this content and will not be able to recover it."
                  theme={theme}
                  checked={this.state.enableContinueDelete}
                  nativeFormControlRef={(x: any) => (this.deleteCBXRef = x)}
                  validate={() => this.checkboxClicked(this.state.enableContinueDelete)}
        />
      </div>
      {!this.state.enableContinueDelete && this.state.validationMessage && <div style={{ color: 'red' }}>{this.state.validationMessage}</div>}
    </DeleteModal>)
  };

  setEnableContinueDelete(state: boolean) {
    this.setState({
      enableContinueDelete: state
    })
  }

  setIsConfirmationDialogShown(state: boolean) {
    this.setState({
      isConfirmationDialogShown: state,
      enableContinueDelete: false,
      validationMessage: '',
    })
  };

  setIsFullPanel(state: boolean) {
    this.setState({
      isFullPanel: state
    });
  };

  handleOnClick(action: ProductCardButtonAction, e: any) {
    switch (action) {
      case ProductCardButtonAction.Delete:
        this.setIsConfirmationDialogShown(true);
        break;
      case ProductCardButtonAction.Edit:
        this.props.editProduct();
        break;
        case ProductCardButtonAction.Duplicate:
          this.props.duplicateProduct();
        break;
      default:
        // Do nothing
    }
  };

  getFullPanelLayout() {
    return (
      <div className={"button-panel"}>
        <Closeable onClickOutside={() => {this.setIsFullPanel(false)}} onEscape={() => {this.setIsFullPanel(false)}}>
          <div id="productButtonPanel" className="button-panel-row">
            {this.getConfirmationDialog()}
            <button title="Rename"
                    aria-label="Rename"
                    className="button-panel-btn"
                    onClick={this.handleOnClick.bind(this, ProductCardButtonAction.Edit)}
                    onMouseEnter={ () => {
                      this.setState({
                        btnHovered: "EDIT"
                      });
                    }}
                    onMouseLeave={() => {
                      this.setState({
                        btnHovered: ""
                      });
                    }}
            ><EditIcon color={this.state.btnHovered === "EDIT" ? "white" : this.VSTUIButtonColor}/></button>
            <button title="Duplicate"
                    aria-label="Duplicate"
                    className="button-panel-btn"
                    onClick={this.handleOnClick.bind(this,  ProductCardButtonAction.Duplicate)}
                    onMouseEnter={ () => {
                      this.setState({
                        btnHovered: "DUPLICATE"
                      });
                    }}
                    onMouseLeave={() => {
                      this.setState({
                        btnHovered: ""
                      });
                    }}
            ><DuplicateIcon color={this.state.btnHovered === "DUPLICATE" ? "white" : this.VSTUIButtonColor}/></button>
            <button title="Delete"
                    aria-label="Delete"
                    className="button-panel-btn"
                    onClick={this.handleOnClick.bind(this,  ProductCardButtonAction.Delete)}
                    onMouseEnter={ () => {
                      this.setState({
                        btnHovered: "DELETE"
                      });
                    }}
                    onMouseLeave={() => {
                      this.setState({
                        btnHovered: ""
                      });
                    }}
            ><DeleteIcon color={this.state.btnHovered === "DELETE" ? "white" : this.VSTUIButtonColor}/></button>
          </div>
        </Closeable>
      </div>
    );
  };

  getDeleteProductLayout() {
    return (
      <div className={'button-panel'}>
        {this.getConfirmationDialog()}
        <div className={'progress-text'}>Import Failed</div>
        <button title="Delete"
              aria-label="Delete"
              className="button-panel-error"
              onClick={this.handleOnClick.bind(this,  ProductCardButtonAction.Delete)}
              onMouseEnter={ () => {
                this.setState({
                  btnHovered: "DELETE"
                });
              }}
              onMouseLeave={() => {
                this.setState({
                  btnHovered: ""
                });
              }}
      ><DeleteIcon color={this.state.btnHovered === "DELETE" ? "white" : this.VSTUIButtonColor}/></button>
      </div>
    );
  }

  getEllipsisColor() {
    if (this.isProcessInProgress()) {
      return EllipsisColor.GREY;
    } else if (this.state.btnHovered === "ELLIPSIS") {
      return EllipsisColor.WHITE;
    } else {
      return this.VSTUIButtonColor;
    }
  }

  isProcessInProgress() {
    return this.props.status !== PRODUCT_STATUS.ACTIVE && this.props.status !== PRODUCT_STATUS.CONVERSION_FAILED
  }

  getProcessInProgressLayout() {
    const displayStatus = this.props.status
      .replace('Conversion', 'Import')
      .replace(PRODUCT_STATUS.TOC_LOCKED, PRODUCT_STATUS.IMPORT_IN_PROGRESS);//FLOE-5918
    return (
      <div className={'button-panel'}>
        <div className={'progress-text'}>{displayStatus}</div>
      </div>
    );
  }
  
  getInitialLayout() {
    return (<button className="button-panel-ellipsis"
            onClick={() => {
              this.setIsFullPanel(true)
            }}
            onMouseEnter={ () => {
              this.setState({
                btnHovered: "ELLIPSIS"
              });
            }}
            onMouseLeave={() => {
              this.setState({
                btnHovered: ""
              });
            }}
    ><EllipsisIcon color={this.getEllipsisColor()}/></button>)
  }

  render() {
    if (this.state.isFullPanel && !this.isProcessInProgress()) {
      return this.getFullPanelLayout();
    } else if (this.props.status === PRODUCT_STATUS.CONVERSION_FAILED) {
      return this.getDeleteProductLayout();
    } else if (this.isProcessInProgress()) {
      return this.getProcessInProgressLayout();
    } else {
      return this.getInitialLayout();
    }
  }
}


export default ButtonPanel;
